var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiscaleView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.29274 10.456c6.0964 2.1898 1.264 5.923 5.0204 7.8457 8.131 2.2327 8.9995-7.6862 0.43263-8.2489-6.3897-2.8333-0.14074-12.474 5.5478-5.807l0.09349 1.6615c0.4589 6.4225 4.566 4.2124 6.1997 4.8276 1.5966 0.12871 2.4885 2.4226 2.4908 3.3494 0.01458 6.0501-5.495 4.0626-7.6085 6.4427-1.0363 1.167-3.2912 5.5107 5.3615 7.2236 3.0261 0.67934 0.68822 5.23 3.7882 6.9965 2.2558 1.7131 5.0043 0.89618 5.8893-0.16028 2.4173-1.9779-1.0288-5.9608 3.4849-6.9537 1.2529-0.79872 3.5492-0.57744 4.3568 0.3793 2.5173 2.9269 0.92968 7.8539 4.5403 7.6181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.453 39.877c0.79418-4.9998 7.0657-7.0118 8.7696 0.07467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.572 17.018c0.06141-3.6186-0.85588-6.9282-5.9758-6.9435-3.8559-0.92699-2.8949-8.2017 1.2134-7.5334 7.3964-1.4336 2.953 7.507 7.3702 7.8703 11.606 0.64992 2.9423 12.169-2.6079 6.6066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.787 0.53497c2.0584 3.4325 3.1486 2.4763 4.8541 2.3704 3.5978 0.37619 2.3872 4.1442 3.0135 5.8634 1.0253 1.6309 1.5019 1.5703 2.3712 2.2274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.735 27.253c-5.7849-2.5036-2.9411-7.9231-0.01804-7.7838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.1601 39.894c3.0377-7.6134 8.3634-3.0756 8.4584-0.0044"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1.1899 35.389c4.3618-0.29923 1.8391-5.7341 4.6468-7.4887 8.6024-2.292 5.2566 6.4986 7.7921 6.7738 7.1858-1.1479 4.9267 3.127 6.9765 4.8835",
    strokeWidth: 1.4397
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.83492 26.944c3.0879-2.1108 4.5777-6.2739 0.015429-7.4431",
    strokeWidth: 1.3698
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.86321 2.939c1.4061 0.034787 2.7598-0.074162 2.4835-2.162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.686 0.73153c2.4954 4.2113 6.8522 2.729 8.1985 0.040502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.445 21.26c2.178-4.8333 10.173-2.1837 7.8518 3.4559-0.58648 3.458-9.7867 4.8302-7.8518-3.4559z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m37.089 0.68377c0.35816 2.8243 1.8461 0.65096 2.8375 1.0221",
    strokeWidth: 1.3749
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiscaleView);
export default __webpack_public_path__ + "static/media/multiscale_view.e775cc580c51dec6b233e2f032a1f25a.svg";
export { ForwardRef as ReactComponent };